export default __webpack_public_path__ + "static/media/hero-image-01.84ffad34.jpg";